/***
 * Model that represents a System Preference.
 */
import Backbone from 'backbone';

var SystemPreference = Backbone.Model.extend({
    idAttribute: 'value',

    urlRoot: function() {
        return '/modern/system-service/preference/' + this.preferenceKey;
    },

    initialize: function(args) {
        if (!args.preferenceKey) {
            throw new Error('preferenceKey is required');
        }

        this.preferenceKey = args.preferenceKey;
    },

    parse: function(response) {
        return response;
    }
});

export default SystemPreference;
